import Layout from "src/components/Layout";
import { defaultURL, bayarOtomatisMeta } from "src/data/DataMetatags";
import NextHead from "src/components/Seo/NextHead";
import BreadcrumbComponent from "src/components/UserInterface/BreadcrumbComponent";
import { bayarOtomatisBreadcrumb } from "src/data/DataBreadcrumb";
import {
  DirectDebitHeader,
  DirectDebitWrapper,
  DirectDebitInformation,
  DirectDebitStepsContent,
  DirectDebitStepSection,
} from "src/views/cara-pembayaran/bayar-otomatis";
import dynamic from "next/dynamic";
import { useWindowSize } from "src/hooks/useWindowSize";

const Widget = dynamic(() => import("src/components/Widget"), {
  ssr: false,
});

export const DIRECT_DEBIT_SECTION = [
  {
    title: "Bayar Otomatis dengan Bank Danamon",
    items: [
      {
        label: "Registrasi Bayar Otomatis Pengguna Baru",
        slug: "/cara-pembayaran/bayar-otomatis/Registrasi Bayar Otomatis Pengguna Baru",
        folder: "Registrasi Bayar Otomatis Pengguna Baru",
        length: 10,
      },
      {
        label: "Registrasi Bayar Otomatis yang Sudah Terdaftar",
        slug: "/cara-pembayaran/bayar-otomatis/Registrasi Bayar Otomatis yang Sudah Terdaftar",
        folder: "Registrasi Bayar Otomatis yang Sudah Terdaftar",
        length: 9,
      },
      {
        label: "Lupa PIN",
        slug: "/cara-pembayaran/bayar-otomatis/Lupa PIN",
        folder: "Lupa Pin",
        length: 4,
      },
    ],
  },
  {
    title: "Bayar Otomatis dengan Bank Lainnya",
    items: [
      {
        label: "Registrasi Bayar Otomatis",
        slug: "/cara-pembayaran/bayar-otomatis/Registrasi Bayar Otomatis",
        folder: "Registrasi Bayar Otomatis",
        length: 8,
      },
    ],
  },
];

const BayarOtomatis = ({ pageTitle, descriptionSEO, asPath, breadcrumb }) => {
  const sections = DIRECT_DEBIT_SECTION;

  const { isMobile } = useWindowSize();

  return (
    <Layout>
      <NextHead
        title={pageTitle}
        description={descriptionSEO}
        url={asPath}
        breadcrumb={breadcrumb}
      />
      <Widget asPath={asPath} />
      <BreadcrumbComponent items={bayarOtomatisBreadcrumb} />
      <DirectDebitWrapper>
        <DirectDebitHeader />
        <DirectDebitInformation />
        <DirectDebitStepSection
          sections={sections}
          selectedItem={sections[0].items[0]}
          render={
            !isMobile && (
              <DirectDebitStepsContent
                title={sections[0].items[0].label}
                folder={sections[0].items[0].folder}
                length={sections[0].items[0].length}
              />
            )
          }
        />
      </DirectDebitWrapper>
    </Layout>
  );
};

BayarOtomatis.getInitialProps = ({ asPath }) => {
  const pageTitle = bayarOtomatisMeta.title;
  const descriptionSEO = bayarOtomatisMeta.description;
  const breadcrumb = [
    {
      "@type": "ListItem",
      position: "1",
      item: {
        "@id": defaultURL,
        name: "Home",
      },
    },
    {
      "@type": "ListItem",
      position: "2",
      item: {
        "@id": defaultURL + asPath,
        name: pageTitle,
      },
    },
  ];
  return { pageTitle, descriptionSEO, asPath, breadcrumb };
};

export default BayarOtomatis;
